import React from "react";
import "../styles/header.css";

export default function Header() {
  return (
    <div className='head'>
      <div className='container-sm pt-1 py-1'>
        <header className='head-text'>
          <img
            src={process.env.PUBLIC_URL + "/ayoba-icon.png"}
            alt='Icon'
            className='header-icon'
          />
          Ayoba Donation
        </header>
      </div>
    </div>
  );
}
